import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';

export enum UpdatePasswordActionType {
    UPDATE_PASSWORD_REQUEST = 'USERS_UPDATE_PASSWORD_REQUEST',
    UPDATE_PASSWORD_SUCCESS = 'USERS_UPDATE_PASSWORD_SUCCESS',
    UPDATE_PASSWORD_FAILURE = 'USERS_UPDATE_PASSWORD_FAILURE',
}

export type UpdatePasswordAction =
    | { type: UpdatePasswordActionType.UPDATE_PASSWORD_SUCCESS; payload: {} }
    | { type: UpdatePasswordActionType.UPDATE_PASSWORD_REQUEST; payload: {} }
    | {
          type: UpdatePasswordActionType.UPDATE_PASSWORD_FAILURE;
          payload: { errorResolution: ErrorResolution };
      };
